import React from "react";
import { Accordion, AccordionSummary, AccordionDetails, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Question from "./Question";

// Renders the advanced settings area as a dedicated component
const AdvancedSettings = ({ question, answers, errors, isVisible, handleChange, renderField }) => {
    const visibleFields = question.fields.filter(field => isVisible(field));

    return (
        <Accordion sx={{ border: '1px solid rgba(0, 0, 0, 0.05)', boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.05)', backgroundColor: '#F2F9F9' }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="advanced-settings-content" id="advanced-settings-header">
                <Grid alignItems="center" spacing={1}>
                    <Grid p={1}>
                        <Typography style={{ marginBottom: 0, fontWeight: 'bold' }}>{question.question}</Typography>
                    </Grid>
                </Grid>
            </AccordionSummary>
            <AccordionDetails>
                {question.tooltip && (
                    <div style={{ 
                        backgroundColor: "#FFFFFF", 
                        padding: "16px", 
                        marginBottom: "16px",
                        borderRadius: "4px",
                        border: "1px solid rgba(0,0,0,0.1)" 
                    }}>
                        {question.tooltip.trim().startsWith("<table") ? (
                            <div dangerouslySetInnerHTML={{ __html: question.tooltip }} />
                        ) : (
                            <Typography variant="body2">{question.tooltip}</Typography>
                        )}
                    </div>
                )}
                <Grid container spacing={2} px={1} pb={2}>
                    {visibleFields.map(field => (
                        <Grid key={field.id} item width={"100%"}>
                            <Question
                                question={field}
                                tooltip={field.tooltip}
                                answers={answers}
                                errors={errors}
                                isVisible={isVisible}
                                handleChange={handleChange}
                            />
                        </Grid>
                    ))}
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default AdvancedSettings;
